// extracted by mini-css-extract-plugin
export default {"header":"styles_header__PzdW9","body":"styles_body__6sZi+"};